import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Swiper from 'react-id-swiper';
import classNames from 'classnames';
import styles from './RecommendList.module.less';
import { setRecentPopopStrategy } from '../../actions/welcome';
import { logNative } from '../../utils/utils';
import { installSoft } from '../../actions/native';
import { logging } from '../../actions/log';
import Checkbox from '../../components/Checkbox/Checkbox';
import Radio from '../../components/Radio/Radio';
import Loading from '../../components/Loading/Loading';

const selectWelcomeData = createSelector(
  state => state.welcome,
  welcome => welcome.welcomeData,
);
const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);
const selectLogInfoData = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

export default memo(({ handleSoftsVisble, firstGuide }) => {
  const [userType, setUserType] = useState([]);
  const [bannerList, setBannerList] = useState([]);
  const [activePage, setActivePage] = useState(0);
  const [count, setCount] = useState(0);
  const welcomeData = useSelector(selectWelcomeData);
  const [recentNotPopup, setRencentNotPopup] = useState(false);
  const installedSoftInit = useSelector(selectLocalSoftsInit);
  const logInfoData = useSelector(selectLogInfoData);
  const dispatch = useDispatch();
  const swiperRef = useRef(null);
  const [sf, setSf] = useState(false);
  const silentInstSoft = useSelector(selectSilentInstSoft);
  const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装
  // dispatch(setRecentPopopStrategy({ opcode: 1 }));
  // 判断是否是新年特变版
  useEffect(() => {
    if (!firstGuide) {
      setSf(false);
    } else {
      setSf(false);
    }
  }, [firstGuide]);
  // 首屏类型打桩
  useEffect(() => {
    if (bannerList && bannerList.length > 0) {
      dispatch(
        logging({
          category: 'I',
          action: 'Welcome_First',
          label: '',
          param2: {
            source: 'Welcome',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: bannerList && bannerList[0] && bannerList[0].code,
          },
        }),
      );
    }
  }, [bannerList, dispatch]);
  // 欢迎页页面展现打桩
  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Welcome',
        label: '',
        param2: {
          source: 'Welcome',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);

  useEffect(() => {
    let userTypeIds = ['1'];
    try {
      userTypeIds = JSON.parse(localStorage.getItem('WELCOME_USER_TYPE')) || ['1'];
      setUserType(userTypeIds);
    } catch (err) {
      logNative(`解析用户欢迎页选中类型出错`);
    }
  }, [installedSoftInit, welcomeData]);

  const handleCount = useCallback(
    data => {
      const checkedList = [];
      (data || bannerList).forEach(pageSoft => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        pageSoft.apps &&
          pageSoft.apps.forEach(soft => {
            if (soft.checked) {
              const newSoft = { ...soft };
              if (!checkedList.find(s => s.softID === soft.softID)) {
                checkedList.push(newSoft.softID);
              }
            }
          });
      });
      return checkedList.length;
    },
    [bannerList],
  );

  useEffect(() => {
    if (
      !welcomeData ||
      !userType ||
      userType.length < 1 ||
      !installedSoftInit ||
      installedSoftInit.length < 1
    ) {
      return;
    }
    let data = userType
      .map(id => {
        return (
          welcomeData.guideResultMap &&
          welcomeData.guideResultMap[id] && {
            ...welcomeData.guideResultMap[id].rankInfo,
            imgUrl: welcomeData.guideResultMap[id].imgUrl,
          }
        );
      })
      .filter(item => item); // 根据用户选择的类型排序
    // 过滤已安装的软件;
    data = data.map(item => {
      return {
        ...item,
        apps: item.apps.filter(app => {
          return !installedSoftInit.find(
            soft => app.softID === soft.SoftID || app.softID === soft.softID,
          );
        }),
      };
    });
    // 根据用户画像个数确定最后的翻页展示数据
    let bannerData = [];
    if (userType.length < 2) {
      const len = data[0] && data[0].apps.length;
      // eslint-disable-next-line radix
      let page = len % 8 === 0 ? parseInt(len / 8) : parseInt(len / 8) + 1;
      while (page > 0) {
        bannerData.unshift({
          ...data[0],
          apps: data[0].apps.slice(
            (page - 1) * 8,
            (page - 1) * 8 + 8 >= len ? len : (page - 1) * 8 + 8,
          ),
        });
        page -= 1;
      }
    } else {
      bannerData = data.map(item => ({ ...item, apps: item.apps.slice(0, 8) }));
    }
    bannerData = bannerData.filter(item => item.apps.length >= 4);
    bannerData = bannerData.map((pageData, index) => {
      return {
        ...pageData,
        checkAll: index === 0,
        apps: index !== 0 ? pageData.apps : pageData.apps.map(soft => ({ ...soft, checked: true })),
      };
    });
    if (Object.keys(welcomeData.guideResultMap).length > 0 && bannerData.length < 1) {
      handleSoftsVisble(false);
    }
    setBannerList(bannerData);
    setCount(handleCount(bannerData));
  }, [welcomeData, installedSoftInit, userType]);

  const goNext = useCallback(() => {
    const nowTime = +new Date();
    let diffTime = nowTime - (window.swiperClickTime || 0);
    if (diffTime > 500) {
      diffTime = 500;
    }
    if (swiperRef !== null) {
      swiperRef.current.swiper.slideNext();
      window.swiperClickTime = nowTime;
    }

    const els = document.querySelectorAll('[data-page]');
    let el = null;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    els &&
      els.forEach(node => {
        if (node.getAttribute('class').indexOf('swiper-pagination-bullet-active') > -1) {
          el = node;
        }
      });

    if (el) {
      const current = +el.getAttribute('data-page');
      setActivePage(+current);
      // 翻页打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Turn_Page',
          label: '',
          param2: {
            source: 'Welcome',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            pagenum: +current,
            type: bannerList && bannerList[+current] && bannerList[+current].code,
          },
        }),
      );
    }
  }, [bannerList, activePage]);
  const goPrev = useCallback(() => {
    const nowTime = +new Date();
    let diffTime = nowTime - (window.swiperClickTime || 0);
    if (diffTime > 500) {
      diffTime = 500;
    }
    if (swiperRef && swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
      window.swiperClickTime = nowTime;
    }
    const els = document.querySelectorAll('[data-page]');
    let el = null;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    els &&
      els.forEach(node => {
        if (node.getAttribute('class').indexOf('swiper-pagination-bullet-active') > -1) {
          el = node;
        }
      });

    if (el) {
      const current = +el.getAttribute('data-page');
      setActivePage(+current);
      // 翻页打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Turn_Page',
          label: '',
          param2: {
            source: 'Welcome',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            pagenum: +current,
            type: bannerList && bannerList[+current] && bannerList[+current].code,
          },
        }),
      );
    }
  }, [bannerList, activePage]);

  const params =
    bannerList && bannerList.length > 1
      ? {
          slidesPerView: 1,
          spaceBetween: 20,
          speed: 800,
          loop: true,
          autoplay: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: (index, className) => {
              return `<div class="${className}" data-page='${index}'>
            <div class="swiper_pagination_round${sf ? '_sf' : ''}"></div>
          </div>`;
            },
          },
          on: {
            slideChange() {
              if (bannerList && bannerList[this.activeIndex - 1]) {
                setActivePage(this.activeIndex - 1);
              }
            },
            click() {
              // 翻页打桩
              dispatch(
                logging({
                  category: 'C',
                  action: 'Turn_Page',
                  label: '',
                  param2: {
                    source: 'Welcome',
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                    pagenum: this && this.activeIndex,
                    type:
                      bannerList &&
                      bannerList[this && this.activeIndex] &&
                      bannerList[this && this.activeIndex].code,
                  },
                }),
              );
            },
          },
        }
      : {
          slidesPerView: 1,
          loop: false,
        };

  const handleCheckSoft = useCallback(
    (soft, index) => () => {
      const data = [...bannerList];
      data[activePage].apps[index] = {
        ...data[activePage].apps[index],
        checked: !data[activePage].apps[index].checked,
      };

      if (!data[activePage].apps[index].checked) {
        data[activePage].checkAll = false;
      } else {
        const notAll = data[activePage].apps.find(item => !item.checked);
        if (notAll) {
          data[activePage].checkAll = false;
        } else {
          data[activePage].checkAll = true;
        }
      }
      setBannerList(data);
      setCount(handleCount(data));
    },
    [activePage, bannerList],
  );
  const handleCheckAllSoft = useCallback(() => {
    const data = [...bannerList];
    data[activePage].checkAll = !data[activePage].checkAll;
    if (data[activePage].checkAll) {
      data[activePage].apps = data[activePage].apps.map(item => ({
        ...item,
        checked: true,
      }));
    } else {
      data[activePage].apps = data[activePage].apps.map(item => ({
        ...item,
        checked: false,
      }));
    }
    setBannerList(data);
    setCount(handleCount(data));
  }, [bannerList, activePage]);
  const handleRecentPopup = () => {
    /** ***********
    默认：isCustomerClick状态为 1，表示 弹
    点击改变：isCustomerClick状态为 0，表示 不弹
    ************* */

    // 不在提醒打桩
    dispatch(
      logging({
        category: 'C',
        action: 'No_Remind',
        label: '',
        param2: {
          source: 'Welcome',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(setRecentPopopStrategy({ opcode: !recentNotPopup ? 0 : 1 }));
    setRencentNotPopup(!recentNotPopup);
  };

  const handleInstallSoft = useCallback(() => {
    // 一键安装打桩

    dispatch(
      logging({
        category: 'C',
        action: 'Xpress_Install',
        label: '',
        param2: {
          source: 'Welcome',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );

    const checkedList = [];
    bannerList.forEach(pageSoft => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      pageSoft.apps &&
        pageSoft.apps.forEach(soft => {
          if (soft.checked) {
            const newSoft = { ...soft };
            newSoft.logInfo = {
              source: 'Welcome',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: soft.softID,
              softName: soft.softName,
              type: 'd',
              url: soft.downLoadUrl,
            };
            // 静默安装判断
            const installparams = {};
            const silentParams = silentInstSoft.find(soft_ => soft_.softID === soft.softID);

            if (isEnabledSilent && silentParams) {
              newSoft.logInfo.type = 'xd';
              if (silentParams.silentParamDic) {
                installparams.quiet = silentParams.silentParamDic;
              }
              if (silentParams.silentDirParamDic) {
                installparams.todir = silentParams.silentDirParamDic;
              }
            }
            if (!checkedList.find(s => s.softID === soft.softID)) {
              dispatch(installSoft({ ...newSoft, installparams, isClick: 'click_welcome' }));
              checkedList.push(newSoft.softID);
            }
          }
        });
    });
    handleSoftsVisble(false);
  }, [bannerList, silentInstSoft]);

  if (!bannerList || bannerList.length < 1) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }
  if (sf) {
    return (
      <>
        <div className={styles.popUp_header}>
          {!sf && (
            <>
              <div className={styles.popUp_title}>
                {bannerList[activePage] && bannerList[activePage].desc}
              </div>
              <div className={styles.popUp_desc}>{count > 0 && <>已选中 {count} 款软件</>}</div>
              <img
                src={bannerList[activePage] && bannerList[activePage].imgUrl}
                alt=""
                className={styles.banner_img}
              />
            </>
          )}
        </div>
        <div className={classNames(styles.nopop, styles.check_all)}>
          <Checkbox
            checked={bannerList[activePage] && bannerList[activePage].checkAll}
            handleChange={handleCheckAllSoft}
            className={
              bannerList[activePage] && bannerList[activePage].checkAll
                ? styles.check_all_top_sf
                : styles.checkno_sf
            }
          >
            <div className={classNames(styles.poptime, { [styles.poptime_sf]: sf })}>全选</div>
          </Checkbox>
        </div>
        <div className={classNames(styles.banner, styles.popUp_banner)}>
          <div className={styles.swiper}>
            <Swiper {...params} ref={swiperRef} noSwiping>
              {bannerList.map((item, i) => (
                <div className={styles.soft_page} key={i}>
                  {item.apps &&
                    item.apps.map((soft, index) => (
                      <div
                        key={`${soft.softID}-${index}`}
                        className={styles.popUp_soft_sf}
                        onClick={handleCheckSoft(soft, index)}
                      >
                        <div className={styles.popUp_soft_check}>
                          <Radio
                            selected={soft.checked}
                            className={
                              soft.checked ? styles.SelectedImg_sf : styles.NoSelectedImg_sf
                            }
                          />
                        </div>
                        <div className={styles.popUp_soft_img}>
                          <img src={soft.logoFile} alt="" data-index={i} />
                        </div>
                        <div className={styles.popUp_soft_name_sf}>{soft.softName}</div>
                      </div>
                    ))}
                </div>
              ))}
            </Swiper>
          </div>
        </div>
        {/* 翻页 */}
        {bannerList.length > 1 && activePage > 0 && (
          <div className={styles.banner_swiper_prev_sf} onClick={goPrev} />
        )}

        {bannerList.length > 1 && activePage < bannerList.length - 1 && (
          <div className={styles.banner_swiper_next_sf} onClick={goNext} />
        )}
        {/* 翻页 */}
        {!firstGuide && (
          <div className={classNames(styles.nopop, styles.recent_check)}>
            <Checkbox
              checked={recentNotPopup}
              className={recentNotPopup ? styles.check_all_top_sf : styles.checkno_sf}
              handleChange={handleRecentPopup}
            >
              <div className={styles.poptime_sf}>近期不再弹出</div>
            </Checkbox>
          </div>
        )}
        <div
          className={classNames(styles.popUp_btn_install_sf, {
            [styles.popUp_btn_install_disabled]: count < 1,
          })}
          onClick={() => {
            if (count > 0) {
              handleInstallSoft();
            }
          }}
        >
          一键安装
        </div>
      </>
    );
  }
  return (
    <>
      <div className={styles.popUp_title}>
        {bannerList[activePage] && bannerList[activePage].desc}
      </div>
      <div className={styles.popUp_desc}>{count > 0 && <>已选中 {count} 款软件</>}</div>
      <img
        src={bannerList[activePage] && bannerList[activePage].imgUrl}
        alt=""
        className={styles.banner_img}
      />
      <div className={classNames(styles.nopop, styles.check_all)}>
        <Checkbox
          checked={bannerList[activePage] && bannerList[activePage].checkAll}
          handleChange={handleCheckAllSoft}
          className={
            bannerList[activePage] && bannerList[activePage].checkAll
              ? styles.checkAll
              : styles.checkno
          }
        >
          <div className={classNames(styles.poptime)}>全选</div>
        </Checkbox>
      </div>
      <div className={classNames(styles.banner, styles.popUp_banner)}>
        <div className={styles.swiper}>
          <Swiper {...params} ref={swiperRef} noSwiping>
            {bannerList.map((item, i) => (
              <div className={styles.soft_page} key={i}>
                {item.apps &&
                  item.apps.map((soft, index) => (
                    <div
                      key={`${soft.softID}-${index}`}
                      className={styles.popUp_soft}
                      onClick={handleCheckSoft(soft, index)}
                    >
                      <div className={styles.popUp_soft_check}>
                        <Radio
                          selected={soft.checked}
                          className={soft.checked ? styles.SelectedImg : styles.NoSelectedImg}
                        />
                      </div>
                      <div className={styles.popUp_soft_img}>
                        <img src={soft.logoFile} alt="" data-index={i} />
                      </div>
                      <div className={styles.popUp_soft_name}>{soft.softName}</div>
                    </div>
                  ))}
              </div>
            ))}
          </Swiper>
        </div>
      </div>
      {/* 翻页 */}
      {bannerList.length > 1 && activePage > 0 && (
        <div className={styles.banner_swiper_prev} onClick={goPrev} />
      )}

      {bannerList.length > 1 && activePage < bannerList.length - 1 && (
        <div className={styles.banner_swiper_next} onClick={goNext} />
      )}
      {/* 翻页 */}
      {!firstGuide && (
        <div className={classNames(styles.nopop, styles.recent_check)}>
          <Checkbox
            checked={recentNotPopup}
            className={recentNotPopup ? styles.checkAll : styles.checkno}
            handleChange={handleRecentPopup}
          >
            <div className={styles.poptime}>近期不再弹出</div>
          </Checkbox>
        </div>
      )}
      <div
        className={classNames(styles.popUp_btn_install, {
          [styles.popUp_btn_install_disabled]: count < 1,
        })}
        onClick={() => {
          if (count > 0) {
            handleInstallSoft();
          }
        }}
      >
        一键安装
      </div>
    </>
  );
});
